














































import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import RecurrenceUtils from "../../utils/recurrenceUtils";
import { Destinataire, RecurrenceRule, Abonnement } from "@/shared/Recurrence";
import ErrorMixin from "@/mixins/errorMixins";
import DestinationAdder from "@/config/recurrences/destinationAdder.vue";

@Component({
  components: {
    DestinationAdder,
  },
})
export default class DestinationRecurrence extends mixins(ErrorMixin) {
  @Prop() public listDests!: Destinataire[];
  @Prop() public destinationAdderComponent!: typeof Vue;
  @Prop({ default: false }) public filterFec!: boolean;
  @Prop() public listRules!: RecurrenceRule[];
  @Prop() public listAbo!: Abonnement[];
  public adding = false;
  public rulesOfDest: any = {};
  public selectedDest: Destinataire = new Destinataire();
  public selectedEmail = "";
  public loading = false;

  public dialogSupprEmail = false;
  public dialogSupprDest = false;

  public msgErreurChampVide = this.$t("msgErreurChampVide").toString();

  public prepareAddDest() {
    this.selectedDest = new Destinataire();
    this.adding = true;
  }

  @Watch("selectedDest", { immediate: true, deep: true })
  public abonnementsDestVerrif() {
    if (!this.selectedDest.$abonnements) {
      this.$set(this.selectedDest, "$abonnements", []);
    }
  }

  /**
   * Méthode permettant d'ajouter un nouveau destinataire
   * @param dest : Destinataire
   */
  public async addDest(dest: Destinataire, resolve: () => void) {
    this.loading = true;
    try {
      const response = await RecurrenceUtils.addDest(dest);

      this.selectedDest.id = response.id;

      resolve();

      this.$emit("addDest", this.selectedDest);

      this.loading = false;
      this.setSuccess(this.$t("destAdded").toString());
    } catch (error) {
      this.loading = false;
      this.setError(error);
      resolve();
    }
  }

  public isSelected(dest: any) {
    return this.selectedDest.id && this.selectedDest.id === dest.id;
  }

  /*
   * Méthode permettant de supprimer un destinataire
   */
  public async deleteDest() {
    this.loading = true;

    await RecurrenceUtils.deleteDest(this.selectedDest.id).then(
      (response: any) => {
        this.$emit("deleteDest", this.selectedDest);
        this.setSuccess(this.$t("destDeleted").toString());
        Vue.set(this, "selectedDest", new Destinataire());
        this.loading = false;
      },
      (error: any) => {
        console.log(error);
        this.loading = false;
        this.setErrorFromTxt(
          "Suppression impossible, merci de verifier les abonnement du destinataire"
        );
      }
    );
  }

  public unsubscribe(evt: any) {
    this.$emit("unsubscribeDest", evt);
  }

  public selectDest(dest: any) {
    dest.$decodedScript = JSON.parse(dest.script);

    Vue.set(this, "selectedDest", dest);
    this.$emit("update:selectedDestinataire", dest);
    this.$forceUpdate();
  }

  /**
   * Méthode permettant de modifier un destinataire
   * @param dest : Destinataire
   */
  public async updateDest(dest: any) {
    this.loading = true;

    RecurrenceUtils.updateDest(dest).then((response: any) => {
      this.setSuccess(this.$t("updateDest").toString());
      this.loading = false;
    });
  }
}
